module.exports = __webpack_public_path__ + "static/logoHostdimeMobile-1ef6f3ca35158b1d09c4724ba292ac68.svg";